import taxAdjustmentAPI from "../../services/taxAdjustmentAPI";
import realexPayment from "@/plugins/realexPayments.js";
import { countryCode } from "@/utils/location-utils.js";
import { parseStringPhoneNumber } from "../../utils/helper-utils";

const appError = {
  applicationError: {
    hasError: true,
    error: [
      " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};

export default {
  healthCheck: ({ commit, dispatch }) => {
    try {
      return taxAdjustmentAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            dispatch("estoreHealthCheck");
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  estoreHealthCheck: ({ commit }) => {
    try {
      taxAdjustmentAPI
        .estoreHealthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  loadStreetNames: async ({ commit }, search) => {
    try {
      await taxAdjustmentAPI.getStreetName(search.searchText).then(response => {
        if (response.status === 200) {
          commit("setStreetNameOptions", response.data);
        } else {
          commit("setErrors", {
            loadStreetNames: {
              hasError: true,
              error: [{ message: "No such names" }]
            }
          });
        }
      });
    } catch (error) {
      console.log(error);
      commit("setErrors", {
        loadStreetNames: {
          hasError: true,
          error: [error]
        }
      });
    }
  },
  getPropertyInfo: ({ commit }, params) => {
    return taxAdjustmentAPI.getPropertyInfo(params).then(
      response => {
        return response.data;
      },
      error => {
        commit("setErrors", appError);
      }
    );
  },
  validateStreetName: async ({ commit }, propertyAddress) => {
    const { streetName, streetNumber } = propertyAddress;
    if (streetName && streetName.length && streetNumber) {
      try {
        await taxAdjustmentAPI
          .validateAddress(streetNumber, streetName)
          .then(response => {
            if (response && response.status === 200) {
              commit("setIsStreetNameValid", response.data);
            } else {
              commit("setIsStreetNameValid", false);
            }
          });
      } catch (error) {
        console.log(error);
        commit("setErrors", appError);
      }
    }
  },
  saveTaxAdjustment: (
    { commit, state, dispatch },
    { taxAdjustmentPayload, addProductPayload }
  ) => {
    try {
      taxAdjustmentAPI
        .postTaxAdjustment(taxAdjustmentPayload)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            commit("setTaxAdjustmentOrderId", response.data);
            commit("setErrors", {
              saveTaxAdjustmentError: {
                hasError: false,
                error: []
              }
            });
            if (
              state?.applicationType?.reasonConfig?.PaymentRequired === false
            ) {
              dispatch("generateRecaptchaToken").then(token => {
                const payload = {
                  ...addProductPayload,
                  domainField1: response.data,
                  billingAddress: {
                    firstName:
                      state?.applicantInformation?.ownerInfo?.firstName ||
                      "",
                    lastName:
                      state?.applicantInformation?.ownerInfo.lastName || "",
                    address:
                      state?.applicantInformation?.mailingInfo?.address || "",
                    city: state?.applicantInformation?.mailingInfo?.city || "",
                    province:
                      state?.applicantInformation?.mailingInfo?.province
                        ?.value ||
                      state?.applicantInformation?.mailingInfo?.province ||
                      "ON",
                    countryISOCode:
                      state?.applicantInformation?.mailingInfo?.country
                        ?.value || countryCode.canada,
                    postalCode:
                      state?.applicantInformation?.mailingInfo?.postalCode ||
                      "",
                    phoneInformation: {
                      phoneNumber:
                        parseStringPhoneNumber(
                          state?.applicantInformation?.ownerInfo
                            ?.phoneNumber
                        ) || ""
                    },
                    email:
                      state?.applicantInformation?.ownerInfo?.email || ""
                  },
                  recaptchaToken: token
                };
                if (!payload.domainField1) {
                  commit("setErrors", appError);
                  return;
                }
                dispatch("postGenericProduct", payload);
              });
            }
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.errors
          ) {
            let formattedErrors = [];
            (Object.values(err.response.data.errors) || []).map(error => {
              if (Array.isArray(error)) {
                formattedErrors.push(...error);
              } else {
                formattedErrors.push(error);
              }
            });
            commit("setErrors", {
              saveTaxAdjustmentError: {
                hasError: true,
                error: formattedErrors
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  postGenericProduct: ({ commit }, payload) => {
    try {
      commit("setErrors", {
        createOrderError: {
          hasError: null,
          error: []
        },
        orderSummaryError: {
          hasError: null,
          error: []
        },
        taxAdjustmentError: {
          hasError: null,
          error: []
        },
        paymentError: {
          hasError: null,
          error: []
        }
      });
      taxAdjustmentAPI
        .postGenericProduct(payload)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            commit("setPostOrderDetails", response.data);
            if (response.data.isFreeOrder !== true) {
              realexPayment.init(
                response.data.realexEndPointUri,
                response.data.paymentResponseUri,
                JSON.parse(response.data.paymentRequestAsJson)
              );
            }
            commit("setErrors", {
              billingErrors: {
                hasError: false,
                error: []
              }
            });
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.errors
          ) {
            let formattedErrors = [];
            (Object.values(err.response.data.errors) || []).map(error => {
              if (Array.isArray(error)) {
                formattedErrors.push(...error);
              } else {
                formattedErrors.push(error);
              }
            });
            commit("setErrors", {
              billingErrors: {
                hasError: true,
                error: formattedErrors
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  fetchTaxAdjustment: ({ commit, dispatch }, params) => {
    try {
      taxAdjustmentAPI
        .getTaxAdjustment(params)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            dispatch("generateRecaptchaToken").then(token => {
              const params = `searchBy=1&rollNumber=${response.data.RollNumber}&recaptchaToken=${token}`;
              dispatch("getPropertyInfo", params).then(properties => {
                commit("setValue", {
                  key: "propertyAddress",
                  value: { properties }
                });
              });
            });
            commit("setTaxAdjustmentDetails", response.data);
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          commit("setErrors", appError);
        });
    } catch (error) {
      console.log(error);
    }
  },
  fetchOrderDetails: ({ commit }, orderId) => {
    try {
      return taxAdjustmentAPI
        .getOrderDetails(orderId)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            commit("setOrderDetails", response.data);
            return response;
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          commit("setErrors", appError);
        });
    } catch (error) {
      console.log(error);
    }
  },
  fetchProduct: ({ commit, dispatch }, productId) => {
    try {
      taxAdjustmentAPI
        .fetchProduct(productId)
        .then(res => {
          if (res.status === 200) {
            commit("setProductDetails", res.data);
            if (res.data?.productClassId) {
              dispatch("generateRecaptchaToken").then(token => {
                const params = {
                  productClassId: res.data.productClassId,
                  recaptchaToken: token
                };
                dispatch("fetchReasonConfigurations", params);
              });
            }
          }
        })
        .catch(error => {
          commit("setErrors", appError);
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  fetchReasonConfigurations: ({ commit }, params) => {
    try {
      taxAdjustmentAPI
        .getReasons(params)
        .then(res => {
          if (res.status === 200) {
            commit("setReasonConfigurations", res.data);
          }
        })
        .catch(error => {
          commit("setErrors", appError);
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  generateRecaptchaToken: ({ commit }) => {
    return new Promise(resolve => {
      grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(
          process.env.VUE_APP_RECAPTCHA_V3_KEY,
          { action: "tax_adjustment" }
        );
        resolve(token);
      });
    }).catch(error => {
      commit("setErrors", appError);
    });
  },
  setValue: ({ commit }, value) => {
    commit("setValue", value);
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  },
  setTaxAdjustmentOrderId: ({ commit }, orderId) => {
    commit("setTaxAdjustmentOrderId", orderId);
  }
};
